module.exports = __webpack_public_path__ + "assets/img/ZT598B-M.8bcadea2.png";